module.exports = __webpack_public_path__ + "static/media/AssignDepartments.5df64f43.svg";